import { Link } from "react-router-dom";
import { MapPin, Phone, Globe, Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const BusinessCard = ({ business, category }) => {
  const defaultLogo = "https://images.unsplash.com/photo-1729830375022-b0248100c501?w=100";
  
  // Use category image as fallback if available
  const logoUrl = business.logo_url || category?.image_url || defaultLogo;

  return (
    <Link
      to={`/entreprise/${business.id}`}
      className="business-card block p-4 group"
      data-testid={`business-card-${business.id}`}
    >
      <div className="flex gap-4">
        {/* Logo */}
        <div className="flex-shrink-0">
          <div className="w-20 h-20 rounded-lg overflow-hidden bg-slate-100 border border-slate-200">
            <img
              src={logoUrl}
              alt={business.name}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.src = category?.image_url || defaultLogo;
              }}
            />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          {/* Header */}
          <div className="flex items-start justify-between gap-2">
            <div>
              <h3 className="font-bold text-slate-900 group-hover:text-[#2563EB] truncate">
                {business.name}
              </h3>
              {category && (
                <Badge variant="secondary" className="mt-1 text-xs">
                  {category.name}
                </Badge>
              )}
            </div>
            {business.has_website_creation && (
              <span className="badge-yellow flex-shrink-0 text-[10px]">Site Web</span>
            )}
          </div>

          {/* Description */}
          <p className="text-sm text-slate-600 mt-2 line-clamp-2">
            {business.description}
          </p>

          {/* Info */}
          <div className="flex flex-wrap items-center gap-4 mt-3 text-sm text-slate-500">
            <span className="flex items-center gap-1">
              <MapPin className="w-4 h-4 text-[#FFD700]" />
              {business.city} ({business.department_code})
            </span>
            {business.phone && (
              <span className="flex items-center gap-1 font-mono">
                <Phone className="w-4 h-4 text-[#2563EB]" />
                {business.phone}
              </span>
            )}
            {business.website && (
              <span className="flex items-center gap-1 text-[#2563EB]">
                <Globe className="w-4 h-4" />
                Site web
              </span>
            )}
          </div>

          {/* Additional activities */}
          {business.additional_activities?.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-2">
              {business.additional_activities.slice(0, 3).map((activity, idx) => (
                <span key={idx} className="text-xs text-slate-500 bg-slate-100 px-2 py-0.5 rounded">
                  {activity}
                </span>
              ))}
            </div>
          )}

          {/* Distance if available */}
          {business.distance_km !== undefined && (
            <div className="mt-2 text-sm font-medium text-[#2563EB]">
              À {business.distance_km} km
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default BusinessCard;
